import { useState, useEffect } from "react";
import SummaryCards from "./SummaryCards";
import { useSelector } from "react-redux";
import TransactionHeader from "./TransactionHeader";
import Transactions from "../../../Transactions/TransactionsTable";
// import TotalAmountSettled from "./TotalAmountSettled";
import { getTransactionTypes } from "redux/actions/transactionActions";
import TransactionTypeStatistics from "../../common/TransactionTypeStatistics";
import TransactionVolumeAnalytics from "../../common/TransactionVolumeAnalytics";
import {
  Typography,
  DateCTA,
  NewDateFIlterModal as DateFilterModal,
} from "components";

import {
  getAllData,
  setTransactionDates,
} from "redux/actions/dashboard/terminalDashboardActions";

const TerminalTransactions = () => {
  const [openDateModal, setOpenDateModal] = useState(false);

  const { dates } = useSelector((state) => ({
    dates: state.terminalDashboardReducer.dates,
  }));

  const handleModalClose = () => setOpenDateModal(false);
  const getAgentsData = () => {
    getAllData();
    handleModalClose();
  };

  useEffect(() => {
    getTransactionTypes();
  }, []);

  return (
    <div className="dashboard-page-container terminal-stats-dashboard ">
      <TransactionHeader />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="d-flex align-items-center cursor-pointer">
            <Typography variant="caption0">Choose Date:</Typography> &nbsp;
            <DateCTA onClick={() => setOpenDateModal(true)} />
          </div>
          {dates.dateFrom && dates.dateTo && (
            <Typography variant="caption2" state="primary" className={"mt-2"}>
              {dates.dateFrom} to {dates.dateTo}
            </Typography>
          )}
        </div>
        <Typography
          variant="caption0"
          state="grey"
          className={"d-block d-sm-none"}
        >
          Scroll right to view all &gt;
        </Typography>
      </div>
      <div className="mt-4 row">
        <div className="col-sm-12 col-xl-7">
          <SummaryCards />
        </div>
        <div className="col-sm-12 col-xl-5">
          <div className=" mt-3">
            <TransactionVolumeAnalytics />
          </div>
        </div>
      </div>
      <div className="mt-4 row">
        {/* <div className="col-sm-12 col-xl-7">
          <TotalAmountSettled />
        </div> */}
        <div className="col-sm-12 col-xl-5 mt-4">
          <TransactionTypeStatistics />
        </div>
      </div>
      <div className="space-top-4">
        <Transactions />
      </div>
      <DateFilterModal
        dateFrom={dates.dateFrom}
        dateTo={dates.dateTo}
        openDateModal={openDateModal}
        onClose={handleModalClose}
        handleFromChange={(val) => setTransactionDates(val, "dateFrom")}
        handleToChange={(val) => setTransactionDates(val, "dateTo")}
        onButtonClick={getAgentsData}
      />
    </div>
  );
};

export default TerminalTransactions;
